import { replace } from "lodash";
import { isWebPlatform } from "@linkfluence/models/platform";
import { PostAuthor } from "@radarly/models/posts";
import { RadarlyAPI } from "./base";

function getBlacklistAuthorCreationPayload(
  project: number,
  author: PostAuthor
) {
  if (isWebPlatform(author.platform)) {
    return {
      projectId: project,
      reversedUrl: author.id,
    };
  }
  return {
    projectId: project,
    userId: author.id,
    screenName: replace(author.screenName || author.name, /^@/, ""),
    name: author.name,
  };
}

export class BlacklistAPI extends RadarlyAPI {
  public async createBlacklistAuthor(project: number, author: PostAuthor) {
    const platform = isWebPlatform(author.platform) ? "web" : author.platform;
    return await this.post<void>(
      `/projects/${project}/blocked/${platform}.json`,
      getBlacklistAuthorCreationPayload(project, author)
    );
  }
}
